PaysEnteteValidator.$inject = ['validator'];

export default function PaysEnteteValidator(validator) {
    const instance = new validator();
    instance.ruleFor('deviseId').notEmpty().withMessage('VALIDATION_NOTEMPTY');

    return instance;
}
